const StatusBadge = ({ status }) => {
  const styles = {
    paid: 'bg-success/10 text-success border-success/20',
    pending: 'bg-gold/10 text-gold border-gold/20',
    overdue: 'bg-maroon/10 text-maroon border-maroon/20',
    partial: 'bg-text-secondary/10 text-text-secondary border-text-secondary/20',
  };

  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`px-2 py-1 text-xs uppercase tracking-widest font-body border ${styles[status] || styles.pending}`}
    >
      {status}
    </span>
  );
};

export default StatusBadge;
